import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=5aed8978"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aed8978')) {
      api.createRecord('5aed8978', component.options)
    } else {
      api.reload('5aed8978', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=5aed8978", function () {
      api.rerender('5aed8978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/Form.vue"
export default component.exports